import React from 'react';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../context/AuthContext';
import DocentOnboardingGate from './DocentOnboardingGate';
import TweestapsPoort from './tweestaps/TweestapsPoort';
import { isLeerlingAccount, LEERLING_START } from '../utils/leerlingAccount';

// Protected Route component - alleen toegankelijk voor ingelogde gebruikers
function ProtectedRoute({ children }) {
  const { currentUser, loading, logout } = useAuth();

  // Wacht tot auth state geladen is (voorkomt redirect-flicker)
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#0D9488',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
      </div>
    );
  }

  // Als er geen gebruiker is ingelogd, redirect naar login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Leerling-account op een docentenpagina: door naar het leerlingportaal.
  if (isLeerlingAccount(currentUser)) {
    return <Navigate to={LEERLING_START} replace />;
  }

  // Anders, toon de beschermde pagina (met noindex voor crawlers). Wie met een
  // wachtwoord inlogt, doet eerst de tweede stap (TweestapsPoort, migratie 105).
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <TweestapsPoort gebruikerId={currentUser.id} onUitloggen={() => logout().catch(() => {})}>
        {children}
        <DocentOnboardingGate />
      </TweestapsPoort>
    </>
  );
}

export default ProtectedRoute;
